var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector, useQuery } from '../../hooks';
import * as api from '../../api/matches';
import { EGamePhase, EGameStatus } from '../../types';
import { Alerts } from '../../components/molecules/Alerts/Alerts';
import { selectMatchState, setMatch, setMatchState } from '../../store/match';
import { IntroduceYourself } from '../../components/organisms/gamePhases/IntroduceYourself/IntroduceYourself';
import { SetRoles } from '../../components/organisms/gamePhases/SetRoles/SetRoles';
import { PlayerIntroducing } from '../../components/organisms/gamePhases/PlayerIntroducing/PlayerIntroducing';
import { SelectRoundDirection } from '../../components/organisms/gamePhases/SelectRoundDirection/SelectRoundDirection';
import { StartRound } from '../../components/organisms/gamePhases/StartRound/StartRound';
import { Vote } from '../../components/organisms/gamePhases/Vote/Vote';
import { ShowPhaseEvents } from '../../components/organisms/gamePhases/ShowPhaseEvents/ShowPhaseEvents';
import { SelectRoleToWakeUp } from '../../components/organisms/gamePhases/SelectRoleToWakeUp/SelectRoleToWakeUp';
import { RolePerformNightAction } from '../../components/organisms/gamePhases/RolePerformNightAction/RolePerformNightAction';
import { Shooting } from '../../components/organisms/gamePhases/Shooting';
import { FinalTable } from '../../components/organisms/gamePhases/FinalTable/FinalTable';
import { useErrorHandler } from '../../hooks/useErrorHandler';
import { BachelorSelecting } from '../../components/organisms/gamePhases/BachelorSelecting/BachelorSelecting';
import { SheriffCheckResult } from '../../components/organisms/gamePhases/SheriffCheckResult/SheriffCheckResult';
export function Match() {
    const { param: matchId } = useQuery('matchId');
    const { errorHandler } = useErrorHandler();
    const dispatch = useAppDispatch();
    const matchState = useAppSelector(selectMatchState);
    const gameStatus = useMemo(() => matchState === null || matchState === void 0 ? void 0 : matchState.gameStatus, [matchState]);
    const getMatch = () => __awaiter(this, void 0, void 0, function* () {
        if (!matchId)
            return;
        try {
            const result = yield api.loadMatch(matchId);
            // console.log('MatchConfig getMatch', result)
            dispatch(setMatch(result));
        }
        catch (e) {
            console.error('MatchConfig getMatch error', e.response);
            errorHandler(e);
        }
    });
    const getMatchState = () => __awaiter(this, void 0, void 0, function* () {
        if (!matchId)
            return;
        try {
            const result = yield api.getMatchState(matchId);
            // console.log('Match getMatchState', result)
            dispatch(setMatchState(result));
            // dividePlayers(result.players)
        }
        catch (e) {
            console.error('Match getMatchState', e.response);
        }
    });
    useEffect(() => {
        getMatch();
        getMatchState();
    }, [matchId]);
    return (_jsxs(_Fragment, { children: [_jsx(Alerts, {}), gameStatus === EGameStatus.GAME_ROLE_SETTING_NIGHT && _jsx(SetRoles, {}), gameStatus === EGameStatus.SELECT_WHO_START_INTRODUCE && _jsx(StartRound, { useCase: "INTRODUCTION" }), gameStatus === EGameStatus.PLAYER_INTRODUCING && _jsx(PlayerIntroducing, {}), gameStatus === EGameStatus.SELECT_DIRECTION_OF_INTRODUCE && _jsx(SelectRoundDirection, { useCase: "INTRODUCTION" }), gameStatus === EGameStatus.INTRODUCE_YOURSELF_STATE && _jsx(IntroduceYourself, {}), gameStatus === EGameStatus.SELECT_WHO_START_VOTING && _jsx(StartRound, { useCase: "VOTE" }), gameStatus === EGameStatus.PLAYER_VOTING && _jsx(Vote, {}), gameStatus === EGameStatus.SELECT_DIRECTION_OF_VOTE && _jsx(SelectRoundDirection, { useCase: "VOTE" }), gameStatus === EGameStatus.PLAYER_VOTE_STATE && _jsx(Vote, {}), gameStatus === EGameStatus.BACHELOR_IS_SELECTING && _jsx(BachelorSelecting, {}), gameStatus === EGameStatus.RUSSIAN_ROULETTE_STATE && _jsx(Shooting, {}), gameStatus === EGameStatus.DAY_RESULT_SHOW_STATE && _jsx(ShowPhaseEvents, { useCase: EGamePhase.DAY }), gameStatus === EGameStatus.SELECT_ROLE_TO_WAKE_UP && _jsx(SelectRoleToWakeUp, {}), gameStatus === EGameStatus.SHERIFF_CHECK_RESULT_STATE && _jsx(SheriffCheckResult, {}), gameStatus === EGameStatus.ROLE_PERFORM_NIGHT_ACTION && _jsx(RolePerformNightAction, {}), gameStatus === EGameStatus.NIGHT_RESULT_SHOW_STATE && _jsx(ShowPhaseEvents, { useCase: EGamePhase.NIGHT }), gameStatus === EGameStatus.FINAL_RESULT && _jsx(FinalTable, {})] }));
}
